export class CourseManagement {

  public static isD2LCourse(course: any): boolean {
    const courseTypes = [3, 4, 5, 6, 10, 7];

    if (course?.courseTypeObject && courseTypes.includes(course.courseTypeObject.id))
      return true;
    return false;
  }

  public static isAttendanceOnly(course: any): boolean {
    if (course?.courseContentType?.courseContentId === 1)
      return true;
    return false;
  }

  public static isCurric(course: any): boolean {
    return CourseManagement.isD2LCourse(course) || CourseManagement.isAttendanceOnly(course);
  }
}
